export default "__VITE_ASSET__D4mt7cDr__"